import { h } from 'preact';
import { useRef } from 'preact/hooks';

export default function FileUpload({ label, accept, onChange }) {
  const inputRef = useRef(null);

  return (
    <div class="file-field">
      <input
        type="file"
        ref={inputRef}
        accept={accept}
        onChange={(e) => onChange(e.target.files[0])}
      />
      <label class="file-field-label" onClick={() => inputRef.current?.click()}>
        <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
        </svg>
        {label}
      </label>
    </div>
  );
}
